import { render, staticRenderFns } from "./ImportPropertiesComponent.vue?vue&type=template&id=cf0b2044&scoped=true"
import script from "./ImportPropertiesComponent.vue?vue&type=script&lang=js"
export * from "./ImportPropertiesComponent.vue?vue&type=script&lang=js"
import style0 from "./ImportPropertiesComponent.vue?vue&type=style&index=0&id=cf0b2044&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf0b2044",
  null
  
)

export default component.exports